module.exports = __webpack_public_path__ + "1c68bac110d3a0b87b2e59cb29e540d0.png";